import Popper from "./Poper";
import {socialMedia} from "../config/data";
import {AiOutlineGithub} from "react-icons/ai";
import {FaDotCircle, FaFacebookSquare, FaLinkedin, FaSkype, FaYoutube} from "react-icons/fa";
import Animate from "./Animate";

function placeIcons(name) {
  if (name === 'GitHub') return (<AiOutlineGithub className={'duration-300 hover:translate-y-1'}/>)
  else if (name === 'Linkedin') return (<FaLinkedin className={'duration-300 hover:translate-y-1'}/>)
  else if (name === 'Facebook') return (<FaFacebookSquare className={'duration-300 hover:translate-y-1'}/>)
  else if (name === 'Skype') return (<FaSkype className={'duration-300 hover:translate-y-1'}/>)
  else if (name === 'Youtube') return (<FaYoutube className={'duration-300 hover:translate-y-1'}/>)
  else return (<FaDotCircle className={'duration-300 hover:translate-y-1'}/>)
}

const SocialMediaLinks = () => {
  return (
      <Animate direction='up' duration={0.4} delay={0.1} distance={60} scrollTriggerStart='bottom bottom'>
        <ul className={'flex justify-start gap-10 items-center my-2'} style={{maxWidth: '260px'}}>
          {socialMedia && socialMedia.map(({url, name}, i) => (
              <li key={i}>
                <a href={url} target='_blank' rel="noreferrer">
                  <Popper title={name}>
                    <div style={{fontSize: 'var(--fz-sub-heading)'}} className={'mx-auto text-center'}>{placeIcons(name)}</div>
                  </Popper>
                </a>
              </li>
          ))}
        </ul>
      </Animate>
  )
}
export default SocialMediaLinks
